import { IconProps } from "../../utils/global-types/global-types";

const HashtagIcon = ({ className, ...rest }: IconProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 20 20"
      className={className ? className : "w-[20px] h-[20px]"}
      {...rest}
    >
      <path
        fill="currentColor"
        d="m10.816 11.027.267-2.177H9.331l-.268 2.177z"
      ></path>
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M6.362 3.217a3.01 3.01 0 0 0-3.01 3.01v7.423a3.01 3.01 0 0 0 3.01 3.01h7.423a3.01 3.01 0 0 0 3.01-3.01V6.227a3.01 3.01 0 0 0-3.01-3.01zm.103 8.346c0-.296.24-.536.536-.536h.983L8.25 8.85h-.772a.536.536 0 0 1 0-1.072h.903l.156-1.265a.536.536 0 1 1 1.064.13l-.14 1.135h1.753l.155-1.265a.536.536 0 0 1 1.065.13l-.14 1.135h.851a.536.536 0 0 1 0 1.072h-.982l-.267 2.177h.772a.536.536 0 1 1 0 1.072h-.904l-.155 1.265a.536.536 0 1 1-1.064-.13l.139-1.135H8.932l-.155 1.265a.536.536 0 1 1-1.064-.13l.14-1.135H7a.536.536 0 0 1-.536-.536"
        clipRule="evenodd"
      ></path>
    </svg>
  );
};

export default HashtagIcon;
